module.exports = __webpack_public_path__ + "img/discord_101785.b8fc0b49.svg";